import React from "react";

const ShareUrlIcon = ({ styles = {}, variations = {}, color = "#3B5FEB" }) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		style={{ ...styles }}
		{...variations}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 0V12H12V6H10.6667V10.6667H1.33333V1.33333H6V0H0ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z"
			fill={color}
		/>
	</svg>
);

export default React.memo(ShareUrlIcon);
